const moreDataInit = () => {
  const tabs = document.querySelectorAll('.more-data-tab')

  const openTab = (tab) => {
    tab.classList.add('active')
  }
  
  const closeTab= (tab) => {
    tab.classList.remove('active')
  }

  if (tabs.length) {
    tabs.forEach((tab) => {
      const tabHeader = tab.querySelector('.tab-inner')
      const lottie = tab.querySelector('lottie-player')

      if (tab.classList.contains('active')) {
        openTab(tab)
        setTimeout(() => {
          lottie.play()
        }, 200)
      }

      tabHeader.addEventListener('click', () => {
        if (tab.classList.contains('active')) {
          closeTab(tab)
          setTimeout(() => {
            lottie.stop()
          }, 200)
        } else {
          openTab(tab)
          setTimeout(() => {
            lottie.play()
          }, 200)
        }
      })
    })
  }
}

moreDataInit()